// General
import React from 'react';
import PropTypes from 'prop-types';

// Google Places Suggest Component
import GoogleMapLoader from 'react-google-maps-loader';
import Geosuggest from 'react-geosuggest';

// Styles
import stylesFn from './PlacesSuggest.styles';
import { colors } from '../../../tailwind';

// Constants
import { googleMapAPI } from '../../../config';

class PlacesSuggest extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    googleMaps: PropTypes.object,
  };

  static defaultProps = {
    personalized: {
      location: null,
    },
  };

  constructor(props) {
    super(props);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSelectSuggest = this.handleSelectSuggest.bind(this);
  }

  handleSearchChange(value) {
    const { change } = this.props;
    if (!value) {
      change(value, 'location');
      change(null, 'lat');
      change(null, 'lng');
    }
  }

  async handleSelectSuggest(data) {
    const { change, handleSubmit } = this.props;
    if (data && data.gmaps) {
      change(data.label, 'location');
      change(data.location.lat, 'lat');
      change(data.location.lng, 'lng');
      if (handleSubmit) {
        handleSubmit();
      }
    }
  }

  render() {
    const { label, className, containerClassName, location } = this.props;
    const containerStyle = {
      display: 'inline-block',
      minWidth: '168px',
    };
    return (
      <GoogleMapLoader
        params={{
          libraries: 'places',
          region: 'US',
          language: 'en',
          key: googleMapAPI,
        }}
        render={googleMaps =>
          googleMaps && (
            <div style={containerStyle}>
              <Geosuggest
                ref={el => (this._geoSuggest = el)}
                placeholder={label}
                inputClassName={className}
                className={containerClassName}
                initialValue={location}
                onChange={this.handleSearchChange}
                onSuggestSelect={this.handleSelectSuggest}
                style={{
                  input: {
                    border: '0px',
                    boxShadow: 'none',
                    borderBottom: '1px solid ' + colors.primaryLight,
                    paddingLeft: 36,
                    width: 160,
                  },
                }}
              />
            </div>
          )
        }
      />
    );
  }
}

export default stylesFn(PlacesSuggest);



// WEBPACK FOOTER //
// ./src/components/SearchListing/PlacesSuggest/PlacesSuggest.js